import React from 'react';
import './SoinsADomicile.css';
import { Link } from 'react-router-dom';
import { FaHandHoldingMedical, FaUserNurse, FaWalking } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const SoinsADomicile = () => {
  const { t } = useLanguage();
  const services = [
    {
      icon: <FaHandHoldingMedical size={40} color="#00c4ff" />,
      title: t('servicesPages.homeCareAidTitle'),
      description: t('servicesPages.homeCareAidBody'),
    },
    {
      icon: <FaUserNurse size={40} color="#00c4ff" />,
      title: t('servicesPages.homeCareNurseTitle'),
      description: t('servicesPages.homeCareNurseBody'),
    },
    {
      icon: <FaWalking size={40} color="#00c4ff" />,
      title: t('servicesPages.homeCareFootTitle'),
      description: t('servicesPages.homeCareFootBody'),
    },
  ];

  return (
    <>
      {/* Section en plein écran */}
      <section className="soins-header">
        <div className="soins-text">
          <h5>{t('servicesPages.label')}</h5>
          <h1>{t('servicesPages.homeCareTitle')}</h1>
          <p>{t('servicesPages.homeCareBody')}</p>
        </div>

        <div className="soins-image-wrapper">
          <div className="purple-bar"></div>
          <img
            src="/images/soin-a-domicile.webp"
            alt="Soins à domicile"
            className="soins-main-image"
          />
        </div>
      </section>

      {/* Cartes des soins */}
      <section className="soins-cards">
        <h5>{t('servicesPages.label')}</h5>
        <h2>{t('servicesPages.homeCareCardsTitle')}</h2>
        <p>{t('servicesPages.homeCareCardsBody')}</p>

        <div className="soins-card-grid">
          {services.map((service, index) => (
            <div key={index} className="soins-card">
              <div className="icon">{service.icon}</div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <Link to="/prendre-rdv" className="rdv-button">
                {t('servicesPages.bookCta')} <span>+</span>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default SoinsADomicile;
